"use client"

import { getLocalizedHref } from "@/lib/locale-utils"
import { formatTimestamp } from "@/lib/utils"
import { SidePostsProps } from "@/types/types"
import Link from "next/link"
import { twMerge } from "tailwind-merge"

const SidePosts = ({ posts, locale = "vi", isVideo = false, youtubeUrlMap = {}, onVideoClick }: SidePostsProps) => {
  if (posts.length === 0) return null

  return (
    <div className="flex flex-col w-full">
      {posts.map(post => {
        const blogUrl = getLocalizedHref(post.attributes.locale, `/${post.attributes.slug}`)
        const youtubeUrl = isVideo ? youtubeUrlMap[post.id] : undefined
        const postTitle = post.attributes?.name || post.attributes?.title || ""
        const publishedAt = post.attributes?.publishedAt || post.attributes?.updatedAt || ""
        const timestamp = publishedAt ? formatTimestamp(publishedAt) : ""

        const handleClick = (e: React.MouseEvent) => {
          if (isVideo && youtubeUrl && onVideoClick) {
            e.preventDefault()
            onVideoClick(youtubeUrl)
          }
        }

        return (
          <div key={post.id}>
            <Link
              href={isVideo && youtubeUrl ? "#" : blogUrl}
              onClick={handleClick}
              className={twMerge("group flex flex-col gap-1", isVideo && youtubeUrl ? "cursor-pointer" : "")}
            >
              {timestamp && (
                <p className="text-[0.625rem] text-black font-normal uppercase leading-[1.2]">{timestamp}</p>
              )}
              <h3 className="text-base font-bold text-black leading-[1.4] group-hover:text-public-brand-strong transition-colors">
                {postTitle}
              </h3>
            </Link>
            <div className="border-t border-dashed border-public-border-subtle sm:my-5 my-2.5"></div>
          </div>
        )
      })}
    </div>
  )
}

export default SidePosts
